module.exports = __webpack_public_path__ + "static/media/galdinsWon_50000.cda00608.png";